// Tag entity types
export enum TagEntityType {
	PART = 'PART',
}

// Tag type definition
export type Tag = {
	id: number;
	label: string;
	color: string;
	associatedPartsCount?: number;
};

// Request/Response types
export type CreateTagRequest = {
	label: string;
	color: string;
};

export type UpdateTagRequest = {
	label?: string;
	color?: string;
};
